import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import combinedServices from "../../../shared/services/user-service";
import { useRecoilState } from "recoil";
import { cartState } from "../../NambaStore/state/cartState";
import swal from "sweetalert";
import POScart from "./POSCart";
import Header from "../../../Components/clubDashboard/Header/Header";
import "./productPage.scss";

const POSproductDetail = () => {
  const { id } = useParams();
  const [productDetailData, setProductDetailData] = useState(null);
  const navigate = useNavigate();
  const [inventoryData, setInventoryData] = useState([]);
  const [attributeKeys, setAttributeKeys] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState({});
  const [filteredOptions, setFilteredOptions] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useRecoilState(cartState);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedInvId, setSelectedInvId] = useState("");
  const [invPrice, setInvPrice] = useState("");
  const [isLastQuantity, setIsLastQuantity] = useState(false);
  const [productAttributes, setProductAttributes] = useState({});

  const openFullScreen = (index) => {
    setCurrentImageIndex(index);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  const location = useLocation();
  const storeId = location.state?.storeId;

  useEffect(() => {
    if (
      productDetailData?.product_type === "inventory" &&
      attributeKeys.length > 0
    ) {
      const updatedAttributes = { ...selectedAttributes };
      let hasChanges = false;

      attributeKeys.forEach((key) => {
        if (!updatedAttributes[key] && filteredOptions[key]?.[0]) {
          updatedAttributes[key] = filteredOptions[key][0];
          hasChanges = true;
        }
      });

      if (hasChanges) {
        setSelectedAttributes(updatedAttributes);

        const matchingInventoryItem = inventoryData.find((item) =>
          attributeKeys.every(
            (attrKey) =>
              item.attribute[attrKey] &&
              item.attribute[attrKey] === updatedAttributes[attrKey]
          )
        );

        if (matchingInventoryItem) {
          setSelectedInvId(matchingInventoryItem.inv_id);
          setInvPrice(matchingInventoryItem.price);
          setIsLastQuantity(matchingInventoryItem.quantity === 1);
        }
      }
    }
  }, [attributeKeys, filteredOptions, inventoryData]);

  useEffect(() => {
    if (
      productDetailData?.product_type === "non_inventory" &&
      Object.keys(productAttributes).length > 0
    ) {
      const updatedAttributes = { ...selectedAttributes };
      let hasChanges = false;

      Object.keys(productAttributes).forEach((key) => {
        if (!updatedAttributes[key] && productAttributes[key]?.[0]) {
          updatedAttributes[key] = productAttributes[key][0];
          hasChanges = true;
        }
      });

      if (hasChanges) {
        setSelectedAttributes(updatedAttributes);
      }
    }
  }, [productAttributes]);

  useEffect(() => {
    const fetchProductsDetails = async () => {
      try {
        const response = await combinedServices.getProductDetailsforUser(id);
        if (response && response.data && response.data.data) {
          console.log("response", response.data.data);
          setProductDetailData(response.data.data.product || {});
          setInventoryData(response.data.data.inventory || []);
          setProductAttributes(response.data.data.product.attributes);
          console.log("asda", response.data.data.product);
          if (response.data.data.inventory.length > 0) {
            setAttributeKeys(
              Object.keys(response.data.data.inventory[0].attribute)
            );
          }
        } else {
          console.error("No product details found.");
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProductsDetails();
  }, [id]);

  useEffect(() => {
    const updatedOptions = {};
    attributeKeys.forEach((key, index) => {
      const dependentAttributes = attributeKeys.slice(0, index);
      const filteredData = inventoryData.filter((item) =>
        dependentAttributes.every(
          (depKey) => item.attribute[depKey] === selectedAttributes[depKey]
        )
      );
      updatedOptions[key] = [
        ...new Set(filteredData.map((item) => item.attribute[key]))
      ];
    });

    setFilteredOptions(updatedOptions);

    if (!selectedInvId) {
      setIsLastQuantity(true);
    }
  }, [selectedAttributes, attributeKeys, inventoryData]);

  const updateQuantity = async (action) => {
    if (productDetailData?.product_type === "non_inventory") {
      let newQuantity = quantity;

      if (action === "increment") {
        newQuantity += 1;
      } else if (action === "decrement" && newQuantity > 1) {
        newQuantity -= 1;
      }

      setQuantity(newQuantity);
      return;
    }

    if (!selectedInvId) {
      alert("Select All Attributes First");
      return;
    }

    let newQuantity = quantity;

    if (action === "increment") {
      if (isLastQuantity) return;
      newQuantity += 1;
    } else if (action === "decrement" && newQuantity > 1) {
      newQuantity -= 1;
    }

    setQuantity(newQuantity);

    try {
      const quantityCheckResponse = await combinedServices.QuantityCheck({
        inv_id: selectedInvId,
        quantity: newQuantity
      });

      const isLastQuantityResponse =
        quantityCheckResponse.data.data?.isLastQuantity || false;

      setIsLastQuantity(isLastQuantityResponse);

      if (quantityCheckResponse.data.status === 200) {
        const updatedCart = cart.map((item) =>
          item.inv_id === selectedInvId
            ? {
              ...item,
              quantity: newQuantity,
              isLastQuantity: isLastQuantityResponse
            }
            : item
        );

        setCart(updatedCart);
      } else {
        alert("Unable to update quantity. Not enough stock.");
        setQuantity(quantity);
      }
    } catch (error) {
      console.error("Error checking quantity:", error);
      setQuantity(quantity);
    }
  };

  const handleChange = (key, value) => {
    const updatedAttributes = { ...selectedAttributes, [key]: value };
    const index = attributeKeys.indexOf(key);
    attributeKeys.slice(index + 1).forEach((depKey) => {
      updatedAttributes[depKey] = "";
    });
    setSelectedAttributes(updatedAttributes);
    const matchingInventoryItem = inventoryData.find((item) =>
      attributeKeys.every(
        (attrKey) =>
          item.attribute[attrKey] &&
          item.attribute[attrKey] === updatedAttributes[attrKey]
      )
    );

    if (matchingInventoryItem) {
      console.log("Matching Inventory Item:", matchingInventoryItem);
      setSelectedInvId(matchingInventoryItem.inv_id);
      setInvPrice(matchingInventoryItem.price);
      if (matchingInventoryItem.quantity === 1) {
        setIsLastQuantity(true);
      } else {
        setIsLastQuantity(false);
      }
    } else {
      setSelectedInvId("");
    }
  };

  const allAttributesSelected = () => {
    if (productDetailData?.product_type === "inventory") {
      return (
        attributeKeys.length > 0 &&
        attributeKeys.every(
          (key) =>
            selectedAttributes[key] && selectedAttributes[key].trim() !== ""
        )
      );
    }
    else if (productDetailData?.product_type === "non_inventory") {
      return (
        Object.keys(productAttributes).length > 0 &&
        Object.keys(productAttributes).every(
          (key) =>
            selectedAttributes[key] && selectedAttributes[key].trim() !== ""
        )
      );
    }
    return false;
  };

  const handleAttributeChange = (key, value) => {
    const updatedAttributes = { ...selectedAttributes, [key]: value };
    setSelectedAttributes(updatedAttributes);
  };

  const handleAddToCart = () => {
    if (!allAttributesSelected()) {
      alert("Please select all attributes before adding to the cart.");
      return;
    }

    if (!quantity || quantity <= 0) {
      alert("Please enter a valid quantity greater than 0.");
      return;
    }

    const matchingInventoryItem = inventoryData.find((item) => {
      return attributeKeys.every(
        (key) => item.attribute[key] === selectedAttributes[key]
      );
    });

    if (!matchingInventoryItem) {
      alert("No matching inventory item found for the selected attributes.");
      return;
    }

    const item = {
      id: productDetailData.product_id,
      inv_id: matchingInventoryItem.inv_id,
      image: productDetailData.images,
      name: productDetailData.product_name,
      price: invPrice,
      quantity,
      attributes: selectedAttributes,
      product_type: productDetailData.product_type,
      storeId: productDetailData.store_id
    };

    const updatedCart = [...cart];
    const existingItemIndex = updatedCart.findIndex((cartItem) => {
      const isSameId = cartItem.id === item.id;
      const areAttributesEqual =
        JSON.stringify(cartItem.attributes || {}) ===
        JSON.stringify(item.attributes || {});
      return isSameId && areAttributesEqual;
    });

    if (existingItemIndex > -1) {
      updatedCart[existingItemIndex] = {
        ...updatedCart[existingItemIndex],
        quantity: updatedCart[existingItemIndex].quantity + quantity
      };
      swal("Success!", "Product updated in cart", "success");
      setSelectedAttributes({});
    } else {
      updatedCart.push(item);
      swal("Success!", "Product updated in cart", "success").then(() => {
        // navigate("/posproductList");
      });
      setSelectedAttributes({});
    }

    setCart(updatedCart);
    localStorage.setItem("POScartItems", JSON.stringify(updatedCart));
  };

  const handleAddToCartNoninv = () => {
    if (!allAttributesSelected()) {
      alert("Please select all attributes before adding to the cart.");
      return;
    }

    if (!quantity || quantity <= 0) {
      alert("Please enter a valid quantity greater than 0.");
      return;
    }

    const item = {
      id: productDetailData.product_id,
      inv_id: 0,
      image: productDetailData.images,
      name: productDetailData.product_name,
      price: productDetailData.retail_price,
      quantity,
      attributes: selectedAttributes,
      product_type: productDetailData.product_type
    };

    const updatedCart = [...cart];
    const existingItemIndex = updatedCart.findIndex((cartItem) => {
      const isSameId = cartItem.id === item.id;
      const areAttributesEqual =
        JSON.stringify(cartItem.attributes || {}) ===
        JSON.stringify(item.attributes || {});
      return isSameId && areAttributesEqual;
    });

    if (existingItemIndex > -1) {
      updatedCart[existingItemIndex] = {
        ...updatedCart[existingItemIndex],
        quantity: updatedCart[existingItemIndex].quantity + quantity
      };
      swal("Success!", "Product updated in cart", "success");
      setSelectedAttributes({});
    } else {
      updatedCart.push(item);
      swal("Success!", "Product updated in cart", "success").then(() => {
        // navigate("/posproductList");
      });
      setSelectedAttributes({});
    }

    setCart(updatedCart);
    localStorage.setItem("POScartItems", JSON.stringify(updatedCart));
  };

  if (!productDetailData) {
    return <div>Loading...</div>;
  }

  const { product_name, retail_price, description, images, sku_code } =
    productDetailData;

  const imageUrls = images ? JSON.parse(images) : [];
  const handleNextImage = () => {
    if (currentImageIndex < imageUrls.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleProductClick = (id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/productDetail/${id}`);
  };

  return (
    <>
      <div className="" >
        <Header />

        <div className="mainCont">
          <section className="ContactOuter" style={{ paddingTop: '20px', paddingBottom: '40px',marginLeft:'90px' }}>
            <div className="container-fluid">
              <div className="row">
                {/* Main content (75% width) */}
                <div className="col-lg-7" style={{ marginTop: "30px",marginLeft:"60px",marginRight:"60px" }}>
                  <div className="row">
                    <div className="col-12 col-md-7 detailImg">
                      <div className="carousel">
                        <button
                          className="carousel-btn prev"
                          onClick={handlePrevImage}
                        >
                          ❮
                        </button>
                        <img
                          src={
                            imageUrls[currentImageIndex] || "/default-image.jpg"
                          }
                          alt={`Product image ${currentImageIndex + 1}`}
                          onClick={() => openFullScreen(currentImageIndex)}
                        />
                        <button
                          className="carousel-btn next"
                          onClick={handleNextImage}
                        >
                          ❯
                        </button>
                        <div className="image-index">
                          {currentImageIndex + 1} / {imageUrls.length}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-5 detailInfo pt-4 pt-md-0 ps-md-4">
                      <div className="name">
                        <span className="d-block mb-2">{product_name}</span> SKU:{" "}
                        {sku_code}
                      </div>
                      <div className="price mt-3">
                        ${invPrice ? invPrice : retail_price} USD
                      </div>
                      <div className="quantityControl d-flex align-items-center mt-4">
                        <button
                          className="quantityBtn"
                          onClick={() => updateQuantity("decrement")}
                          disabled={
                            productDetailData?.product_type === "inventory"
                              ? quantity === 1
                              : quantity === 1
                          }
                        >
                          -
                        </button>
                        <span className="quantityDisplay mx-2">{quantity}</span>
                        <button
                          className="quantityBtn"
                          onClick={() => updateQuantity("increment")}
                          disabled={
                            productDetailData?.product_type === "inventory"
                              ? isLastQuantity
                              : false
                          }
                        >
                          +
                        </button>
                      </div>
                      <div className="mt-4 d-flex flex-wrap">
                        {productDetailData?.product_type === "inventory" &&
                          attributeKeys.map((key, index) => (
                            <div
                              key={index}
                              className="attribute-dropdown col-6 pe-2 pb-2"
                            >
                              <label className="d-block mb-1">{key}</label>
                              <select
                                className="formSelect"
                                value={selectedAttributes[key] || ""}
                                onChange={(e) =>
                                  handleChange(key, e.target.value)
                                }
                              >
                                <option value="">Select {key}</option>
                                {filteredOptions[key]?.map((option, idx) => (
                                  <option key={idx} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ))}
                      </div>
                      <div className="mt-4 d-flex flex-wrap">
                        {productDetailData?.product_type === "non_inventory" &&
                          Object.keys(productAttributes).map((key, index) => (
                            <div
                              key={index}
                              className="attribute-dropdown col-6 pe-2 pb-2"
                            >
                              <label className="d-block mb-1">{key}</label>
                              <select
                                className="formSelect"
                                value={selectedAttributes[key] || ""}
                                onChange={(e) =>
                                  handleAttributeChange(key, e.target.value)
                                }
                              >
                                <option value="">Select {key}</option>
                                {productAttributes[key].map((option, idx) => (
                                  <option key={idx} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ))}
                      </div>
                      <div className="addCart mt-4">
                        {productDetailData?.product_type === "inventory" && (
                          <button
                            type="button"
                            onClick={handleAddToCart}
                            disabled={!allAttributesSelected()}
                          >
                            Add to Cart
                          </button>
                        )}

                        {productDetailData?.product_type === "non_inventory" && (
                          <button
                            type="button"
                            onClick={handleAddToCartNoninv}
                            disabled={!allAttributesSelected()}
                          >
                            Add to Cart
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="pt-5 desText">
                    <h2>Product Details</h2>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                  </div>
                </div>
                <POScart storeId={storeId} />
              </div>
            </div>
          </section>
        </div>
      </div>
      {isImageModalOpen && (
        <div className="image-modal">
          <div className="image-modal-content">
            <button className="close-button" onClick={closeImageModal}>
              ✖
            </button>
            <div className="image-container">
              <img
                src={imageUrls[currentImageIndex]}
                alt="Full Screen Image"
                className="modal-image"
              />
            </div>
            <div className="image-navigation">
              <button
                className="prev-button"
                onClick={() =>
                  setCurrentImageIndex(
                    currentImageIndex > 0
                      ? currentImageIndex - 1
                      : imageUrls.length - 1
                  )
                }
              >
                ❮
              </button>
              <button
                className="next-button"
                onClick={() =>
                  setCurrentImageIndex(
                    currentImageIndex < imageUrls.length - 1
                      ? currentImageIndex + 1
                      : 0
                  )
                }
              >
                ❯
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default POSproductDetail;